import userSlice from './slice';

export const {
  currentAction,
  currentFailedAction,
  currentSucceededAction,
  setUserIdAction,
  setIsAuthorizeAction,
  logoutUserAction,
  setIsSuperAdminAction,
  logoutUserFailedAction,
  updateCurrent,
  updateCurrentSuccess,
  updateCurrentError,
  deleteCurrent,
  deleteCurrentError,
  deleteCurrentSuccess,
  updateCurrentUserOrganizationInfoSuccess,
  updateCurrentUserOrganizationInfo,
  updateCurrentUserOrganizationInfoError,
  updateUserNotification,
  updateUserNotificationSuccess,
  updateUserNotificationError,
  acceptEulaSuccess,
  acceptEulaError,
  acceptEula,
  checkAcceptedEula,
  checkAcceptedEulaSuccess,
  checkAcceptedEulaError,
  setCopiedLinkfilterByPage,
  FireCopiedLinkfilterByPage,
  putsiteUUID,
  FirePutsiteUUID
} = userSlice.actions;
export default userSlice.reducer;

export * from './types';
